import React, { useState } from "react";
import classnames from "classnames";
import { getPseudoObjectId } from "@ecologi/shared";
import { Button } from "../../Button";
import { AddNewItemProps } from "./AddNewItem";

import styles from "../styles/AddNewItem.module.scss";

export const AddNewItemBusiness = ({
  user,
  onAddChecklistItem,
}: AddNewItemProps) => {
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const isFirstGoal = (user.checklistItems || []).length === 0;

  return (
    <div
      className={classnames(styles.addNewItem, styles.addNewItemBusiness, {
        [styles.addNewItemEmptyList]: isFirstGoal,
      })}
    >
      <form
        className={styles.addNewItemBusinessForm}
        onSubmit={async (e) => {
          e.preventDefault();

          const label = inputValue.trim();

          if (!label) {
            return;
          }

          // Generate a new Mongo ObjectId like string for the value
          const item = { label, value: getPseudoObjectId() };

          setIsLoading(true);
          await onAddChecklistItem(user, item, () => {
            setInputValue(""); // reset the input
          });
          setIsLoading(false);
        }}
      >
        <input
          className={styles.freeTextInput}
          id="text"
          name="text"
          onChange={(e) => setInputValue(e.currentTarget.value)}
          placeholder={
            isFirstGoal
              ? "Add your first sustainable business goal"
              : "Add another sustainable business goal"
          }
          type="text"
          value={inputValue}
        />
        <Button submit text="Add goal" primary small disabled={isLoading} />
      </form>
    </div>
  );
};
